import { createContext, useContext, ReactNode } from 'react';
import { useOrgs } from './OrgsContext';

interface RolesContextType {
  isAdmin: boolean;
  isAdminOrOperator: boolean;
  isBillingManager: boolean;
}

const RolesContext = createContext<RolesContextType | undefined>(undefined);

export function RolesProvider({ children }: { children: ReactNode }) {
  const { selectedOrganization } = useOrgs();

  // Calculate role based on currently selected organization.
  const isAdmin = selectedOrganization?.role === 'Administrator';
  const isOperator = selectedOrganization?.role === 'Operator';
  const isBillingManager = selectedOrganization?.role === 'Billing';

  return (
    <RolesContext.Provider value={{
      isAdmin,
      isAdminOrOperator: isAdmin || isOperator,
      isBillingManager,
    }}>
      {children}
    </RolesContext.Provider>
  );
}

export function useRoles() {
  const context = useContext(RolesContext);
  if (context === undefined) {
    // eslint-disable-next-line no-restricted-syntax
    throw new Error('useRoles must be used within a RolesProvider');
  }
  return context;
}
